import React, { useEffect, useState } from 'react';
import { getGeneralSettings, updateGeneralSettings } from '../../lib/reportStudioApi';
import { useClubIdentity } from '../../lib/useClubIdentity';
import SettingsFieldsForm from './SettingsFieldsForm';
import ReportPreviewMock from './ReportPreviewMock';
import { PrimaryBtn } from '../../pages/organization/finance/shared';

export default function GeneralSettingsSection({ canManage }) {
  const identity = useClubIdentity();
  const [draft, setDraft] = useState(null);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => { getGeneralSettings().then(setDraft); }, []);
  const notify = (m) => { setToast(m); setTimeout(() => setToast(null), 2500); };

  const save = async () => {
    setSaving(true);
    try { await updateGeneralSettings(draft); notify('تم حفظ الإعدادات العامة'); }
    catch { notify('فشل الحفظ'); }
    setSaving(false);
  };

  if (!draft) return <div className="h-40 animate-pulse rounded-xl bg-slate-100" />;

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.3fr_1fr]" data-testid="rs-general-section">
      {toast && <div className="fixed top-16 left-1/2 z-50 -translate-x-1/2 rounded-lg bg-[#16233b] px-4 py-2 text-sm text-white shadow-lg">{toast}</div>}
      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <p className="mb-3 text-sm text-slate-500">هذه الإعدادات هي الافتراضية لجميع تقارير المنشأة، وتُطبَّق على أي تقرير لم يُخصَّص له إعداد مستقل.</p>
        <SettingsFieldsForm value={draft} onChange={setDraft} testPrefix="rs-general" />
        {canManage && <div className="mt-4 flex justify-end"><PrimaryBtn onClick={save} disabled={saving} data-testid="rs-general-save-btn">{saving ? 'جارٍ الحفظ...' : 'حفظ الإعدادات العامة'}</PrimaryBtn></div>}
      </div>
      <div>
        <p className="mb-2 text-xs font-bold text-slate-500">معاينة مباشرة</p>
        <ReportPreviewMock settings={draft} identity={identity} reportTitle="التقرير العام" />
      </div>
    </div>
  );
}
